import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { faCheck, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BCard, BCardBody, BCardTitle } from "bootstrap-vue";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'GenericWizard',
    props: {
        use: { default: undefined },
        title: { default: "Generic Wizard" },
        submitButtonLabel: { default: "Submit" },
        isBusy: { type: Boolean, default: false }
    },
    emits: ["submit"],
    setup(__props, { emit }) {
        const props = __props;
        _useCssVars((_vm, _setup) => ({
            "41aeeaaf": (_setup.stepsGridColumnsTemplate)
        }));
        function goNext() {
            var _a;
            if (props.use.current.value.isValid()) {
                if (props.use.isLast.value) {
                    emit("submit");
                }
                let nextStepIndex = props.use.index.value + 1;
                let nextStepName = props.use.stepNames.value.at(nextStepIndex);
                while (nextStepName && ((_a = props.use.steps.value[nextStepName]) === null || _a === void 0 ? void 0 : _a.isSkippable())) {
                    nextStepIndex++;
                    nextStepName = props.use.stepNames.value.at(nextStepIndex);
                }
                if (nextStepName) {
                    props.use.goTo(nextStepName);
                }
            }
        }
        function goBack() {
            var _a;
            let previousStepIndex = props.use.index.value - 1;
            let previousStepName = props.use.stepNames.value.at(previousStepIndex);
            while (previousStepName && ((_a = props.use.steps.value[previousStepName]) === null || _a === void 0 ? void 0 : _a.isSkippable())) {
                previousStepIndex--;
                previousStepName = props.use.stepNames.value.at(previousStepIndex);
            }
            if (previousStepName) {
                props.use.goTo(previousStepName);
            }
        }
        function determineDisplayStepIndex(index) {
            const steps = Array.from(Object.values(props.use.steps.value));
            return steps.slice(0, index).filter((step) => !step.isSkippable()).length + 1;
        }
        function allStepsBeforeAreValid(index) {
            const steps = Array.from(Object.values(props.use.steps.value));
            return steps.slice(0, index).every((step) => step.isValid() || step.isSkippable());
        }
        function isStepDone(currentIndex) {
            return currentIndex < props.use.index.value;
        }
        /**
         * This is a workaround to make the grid columns template dynamic based on the number of visible steps.
         */
        const stepsGridColumnsTemplate = computed(() => {
            const numVisibleSteps = Array.from(Object.values(props.use.steps.value)).filter((step) => !step.isSkippable()).length;
            return (Array(numVisibleSteps - 1)
                .fill("auto")
                .join(" ") + " max-content");
        });
        return { __sfc: true, props, emit, goNext, goBack, determineDisplayStepIndex, allStepsBeforeAreValid, isStepDone, stepsGridColumnsTemplate, faCheck, faSpinner, FontAwesomeIcon, BCard, BCardBody, BCardTitle };
    }
});
